<template>
  <div
    class="zm-select-dropdown zm-popper"
    :class="[{ 'is-multiple': $parent.multiple,'is-multi-remote': $parent.remote && $parent.multiple }, popperClass]"
    :style="{ minWidth: minWidth, width: widthLimit ? minWidth : 'auto' }">
    <slot></slot>
  </div>
</template>

<script type="text/babel">
  import Popper from '../../utils/vue-popper';

  export default {
    name: 'ZmSelectDropdown',

    componentName: 'ZmSelectDropdown',

    mixins: [Popper],

    props: {
      placement: {
        default: 'bottom-start'
      },

      boundariesPadding: {
        default: 0
      },

      popperOptions: {
        default() {
          return {
            gpuAcceleration: false
          };
        }
      },

      visibleArrow: {
        default: false
      },

      appendToBody: {
        type: Boolean,
        default: true
      },
      widthLimit: [Boolean, Object],
    },

    data() {
      return {
        minWidth: ''
      };
    },

    computed: {
      popperClass() {
        return this.$parent.popperClass;
      }
    },

    watch: {
      '$parent.inputWidth'() {
        this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
      }
    },

    mounted() {
      this.referenceElm = this.$parent.$refs.reference;
      this.$parent.popperElm = this.popperElm = this.$el;
      this.$on('updatePopper', () => {
        if (this.$parent.visible) {
          this.$nextTick(this.updatePopper);
        }
      });
      this.$on('destroyPopper', this.destroyPopper);
    }
  };
</script>

<style lang="scss">
  @import "../../scss/common/popper";
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(select-dropdown) {
    position: absolute;
    z-index: #{$--index-top + 1};
    border-radius: $--select-dropdown-border-radius;
    background-color: $--select-dropdown-background;
    box-shadow: $--select-dropdown-shadow;
    box-sizing: border-box;
    margin: 0;
    margin-top: 4px;

    @include when(multiple) {
      & .zm-select-dropdown__item.selected {
        color: $--select-option-selected;
        background-color: $--select-dropdown-background;

        &.hover {
          background-color: $--select-option-hover-background;
        }
      }
    }

    @include when(multi-remote) {
      & .zm-select-dropdown__item {
        color: $--select-option-selected;

        &.selected {
          color: $--select-option-disabled-color;
        }

        &.hover {
          background-color: $--select-option-hover-background;
        }
      }
    }

    .zm-scrollbar.is-empty {
      height: 0;
    }

    .zm-scrollbar.is-empty .zm-select-dropdown__list {
      padding: 0;
    }
    .zm-select-dropdown__item__span {
      display: block;
    }
  }

  @include b(select-dropdown__empty) {
    padding: $--select-dropdown-empty-padding;
    margin: 0;
    text-align: center;
    color: $--select-dropdown-empty-color;
    font-size: $--select-font-size;
  }

  @include b(select-dropdown__wrap) {
    // max-height: $--select-dropdown-max-height;
    /*padding-bottom: 17px;*/

    .zm-tree-node__label {
      padding-right: 10px;
    }

    .zm-checkbox-list__row {
      padding: 0 10px;
      line-height: 26px;
      &:hover {
        background-color: $--background-color-hover;
      }
    }
    .zm-checkbox-list {
      padding: 0;
    }
  }

  @include b(select-dropdown__list) {
    list-style: none;
    padding: $--select-dropdown-padding;
    margin: 0;
    box-sizing: border-box;

    &:focus {
      outline: none;
    }
  }

</style>
